import React, { useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';
import './InvisibleInput.scss';

export interface IInvisibleInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  className?: string;
}

function InvisibleInput({ value, placeholder, onChange, className }: IInvisibleInputProps): JSX.Element {
  const inputEl = useRef<HTMLTextAreaElement>(null);

  const autoGrow = useCallback(() => {
    if (inputEl.current) {
      const element = inputEl.current;
      element.style.height = '16px';
      element.style.height = `${element.scrollHeight}px`;
    }
  }, [inputEl]);

  useEffect(() => autoGrow(), [autoGrow, value]);

  return <textarea
    ref={inputEl}
    rows={1}
    className={classNames('invisible-input', className)}
    value={value}
    placeholder={placeholder}
    onChange={e => onChange(e.target.value)}
    onInput={autoGrow}
  />;
}

export default InvisibleInput;
